import lang from '../../../../../lib/language';
import { InfoStatusType } from '../../../../../lib/models/market-data/types';

import styles from '../ChartHeader.module.scss';

const InfoStatus = ({ type }: { type: InfoStatusType }) => (
  <span className={styles.infoStatus}>
    { type === 'pre' && lang.commonMarketHoursPre() }
    { type === 'after' && lang.commonMarketHoursAfter() }
    { type === 'close' && lang.commonMarketHoursAtClose() }
  </span>
);

export default InfoStatus;
